import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import de_DE from 'vuetify/es5/locale/de';
import en_US from 'vuetify/es5/locale/en';

Vue.use(Vuetify);

// vuetify has no locale fallback available
// so be sure, that locale is correct
if(window.mmconfig.locale !== 'de_DE') {
  window.mmconfig.locale = 'en_US';
}

export default new Vuetify({
    lang: {
      locales: { de_DE, en_US },
      current: window.mmconfig.locale,
    },
});
